import Footer from "../components/Footer";
import { Check, ChevronLeft, ChevronRight, Copy } from "lucide-react";
import toast, { Toaster } from "react-hot-toast";
import MainHeader from ".././components/MainHeader";
import { Link } from "react-router-dom";
import panelVanOffer from "../components/assets/panelvan_offer_desktop.png";
import toronto_city from "../components/assets/toronto-city.jpg";
import ottawa_city from "../components/assets/ottawa-city.jpg";
import montreal_city from "../components/assets/montreal-city.jpg";
import calgary_city from "../components/assets/calgary_city.png";
import panel_van from "../components/assets/panel-van.png";
import van1 from "../components/assets/image-1.png";
import van2 from "../components/assets/image-2.png";
import React, { useState } from "react";

const CommercialFleet = () => {
  const [copied, setCopied] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText("MOVE15");
    setCopied(true);
    toast.success("Promo code copied!", {
      duration: 2000,
      icon: "📋",
    });

    setTimeout(() => setCopied(false), 2000);
  };

  const promos = {
    title: "Promo Terms & Conditions",
    terms: [
      <>
        Offer is available for{" "}
        <strong>Toronto, Calgary, Ottawa and Montreal</strong> locations only.
      </>,
      <>
        Use the promo code <span className="text-black font-bold">MOVE15</span>{" "}
        to claim this offer.
      </>,
      <>
        Offer may not be used in conjunction with any other promo code,
        promotion, or offer.
      </>,
      <>
        Discount valid on rentals checked out no later than{" "}
        <strong>June 30, 2025</strong>.
      </>,
      <>
        Offer is subject to vehicle availability and may not be available on
        select online rates at{" "}
        <a
          href="https://www.routes.ca"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#001dab] underline"
        >
          routes.ca
        </a>
        .
      </>,
      <>Car rental return restrictions may apply.</>,
      <>Offers are subject to change without notice.</>,
      <>Long weekend/holidays and other blackout periods may apply.</>,
      <>Renter must meet Routes age, driver, and credit card requirements.</>,
      <>Renter must meet our guidelines policy.</>,
      <>
        Additional restrictions may apply, refer to rental policy page for more
        information. You will find the rental policy page at the checkout.
      </>,
    ],
  };

  const locations = [
    {
      name: "Toronto",
      img: toronto_city,
      latlng: { lat: 43.69602, long: -79.62993 },
    },
    {
      name: "Ottawa",
      img: ottawa_city,
      latlng: { lat: 45.319191, long: -75.624298 },
    },
    {
      name: "Calgary",
      img: calgary_city,
      latlng: { lat: 51.134918, long: -114.034286 },
    },
    {
      name: "Montreal",
      img: montreal_city,
      latlng: { lat: 45.453017, long: -73.734414 },
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? locations.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === locations.length - 1 ? 0 : prev + 1));
  };
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <MainHeader />
      <Toaster position="top-center" />

      {/* Hero Image */}
      <div className="bg-white rounded-lg shadow-lg relative z-10 max-w-8xl mx-auto p-4 sm:p-6  text-center">
        <div className="w-full overflow-hidden relative">
          <img
            src={panelVanOffer}
            alt="Truck and Van Deals"
            className="w-full object-contain"
          />
        </div>

        {/* Main Offer Content */}
        <h1 className="text-xl sm:text-3xl md:text-3xl font-extrabold text-[#1E40AF] mt-6 mb-4 tracking-tight">
          Move Smarter with Spacious Cargo Vans – Now Available at Ottawa,
          Toronto, Montreal & Calgary!
        </h1>
        <p className="text-gray-600 text-base  mx-auto text-center justify-center sm:text-base md:text-lg mb-2">
          Looking for a reliable cargo van rental? Our spacious moving vans are
          ideal for house moves, business deliveries, event setups, and
          furniture transport. Our panel vans offer the perfect balance of space
          and efficiency, ensuring a smooth hauling experience. Whether you're
          shifting apartments or managing a business, our rental trucks are
          ready for the job. Available in{" "}
          <strong>Ottawa, Toronto, Montreal, and Calgary</strong>– book your
          cargo van today!
        </p>
        <button
          onClick={() => setShowTerms(!showTerms)}
          className="w-full text-orange-600 hover:text-orange-700 underline font-medium py-2 text-sm sm:text-base text-center tracking-wide"
        >
          {showTerms ? "Hide Terms & Conditions" : "View Terms and Conditions"}
        </button>

        {showTerms && (
          <div className="mt-2 mb-4 sm:mx-auto sm:max-w-4xl bg-white border border-gray-200 rounded-2xl shadow-sm px-6 py-6 transition-all duration-300">
            <div className="space-y-1 text-gray-700 text-sm sm:text-base leading-relaxed">
              {promos.terms.map((term, idx) => (
                <div key={idx} className="flex items-start gap-3 text-left">
                  <span className="text-orange-500 text-base font-bold">•</span>
                  <p className="flex-1">{term}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* <div className="bg-green-100 text-green-800 font-semibold text-sm sm:text-sm md:text-base p-3 sm:p-4 rounded mb-6 text-center">
            Use Code: <span className="text-green-900">MOVE15</span> | Valid
            Until: May 15th
  
          </div> */}

        <div className="bg-green-100 text-green-800 rounded-md p-3 sm:p-4 mb-6 text-center text-xs sm:text-sm md:text-base font-semibold flex flex-row justify-center items-center gap-2 flex-wrap">
          Use Code:{" "}
          <span className="font-bold flex items-center py-1 rounded">
            MOVE15
            <button
              onClick={handleCopy}
              className="text-green-800 hover:bg-green-200 p-1 rounded transition"
              title="Copy Code"
            >
              {copied ? <Check size={14} /> : <Copy size={14} />}
            </button>
          </span>
          <span>| Valid Until: June 15th</span>
        </div>

        {/* Available Fleet Section */}
        <div className="mt-6 text-center">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-[#1E40AF] mb-2 tracking-tight">
            Available Fleet
          </h2>
          {/* Note */}
          {/* <p className="text-md text-red-600 font-extrabold tracking-tight">
              Note: Prices will not be shown in the final edit
            </p> */}

          {/* Fleet Images */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-20 mb-4">
            <Link to="/">
              <img
                src={van1}
                alt="Fleet Van 1"
                className="w-[300px] h-[500px] object-cover rounded-md shadow"
              />
            </Link>
            <Link to="/">
              <img
                src={van2}
                alt="Fleet Van 2"
                className="w-[300px] h-[500px] object-cover rounded-md shadow"
              />
            </Link>
          </div>
        </div>

        <Link to="/">
          <button className="bg-[#1E40AF] text-white px-6 py-2 rounded hover:bg-blue-800 transition">
            Rent Now
          </button>
        </Link>
      </div>

      {/* Introductory Section */}
      {/* <div className="max-w-4xl mx-auto px-4 sm:px-6 mt-10 text-center">
          <h2 className="text-2xl font-bold text-[#1E40AF] mb-2 tracking-tight">
            Why Choose Us?
          </h2>
          <p className="text-gray-600 text-md">
            We offer reliable and spacious panel vans and cube trucks ideal for
            moving, business deliveries, or long-distance hauling. Backed by
            exceptional service and unbeatable rates.
          </p>
        </div> */}

      {/* Available Locations Section */}
      <div className="max-w-6xl mx-auto px-6 mt-8">
        <h2 className="text-2xl md:text-3xl sm:text-xl font-extrabold text-[#1E40AF] mb-6 text-center tracking-tight">
          Available Locations
        </h2>

        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 mb-8">
          {locations.map((loc, idx) => (
            <div
              key={idx}
              className="rounded overflow-hidden shadow-md bg-white"
            >
              <img
                src={loc.img}
                alt={loc.name}
                className="w-full h-70 object-cover"
              />
              <div className="p-3 text-center">
                <h3 className="text-[#1E40AF] font-semibold text-lg mb-1">
                  {loc.name}
                </h3>
                <a
                  href={`https://www.google.com/maps?q=${loc.latlng.lat},${loc.latlng.long}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-sm mb-2 bg-blue-600 px-3 py-2 rounded-lg shadow-md border-blue-2 transition duration-200 inline-block"
                >
                  Direction
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden relative flex justify-center items-center mb-8">
          <button
            onClick={handlePrev}
            className="absolute left-0 z-10 bg-white p-2 rounded-full shadow hover:bg-gray-100"
          >
            <ChevronLeft />
          </button>

          <div className="w-full max-w-xs bg-white rounded-lg  shadow-md text-center mx-4">
            <img
              src={locations[currentIndex].img}
              alt={locations[currentIndex].name}
              className="w-full h-70 object-cover"
            />
            <div className="p-3">
              <h3 className="text-[#1E40AF] font-semibold text-lg mb-2">
                {locations[currentIndex].name}
              </h3>
              <a
                href={`https://www.google.com/maps?q=${locations[currentIndex].latlng.lat},${locations[currentIndex].latlng.long}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-sm mb-2 bg-blue-600 px-3 py-2 rounded-lg shadow-md border-blue-2 transition duration-200 inline-block"
              >
                Direction
              </a>
            </div>
          </div>

          <button
            onClick={handleNext}
            className="absolute right-0 z-10 bg-white p-2 rounded-full shadow hover:bg-gray-100"
          >
            <ChevronRight />
          </button>
        </div>
      </div>

      <div className="bg-white p-2">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-[#1E40AF] mt-6 mb-4 tracking-tight">
            Reliable, Spacious, and Affordable – Cargo Vans for Every Need!
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto mb-10">
            Whether you're moving house, managing deliveries, or planning a big
            event, our cargo vans are built for flexibility and comfort. See why
            customers across Canada trust our fleet.
          </p>
          <div className="max-w-4xl mx-auto rounded-lg overflow-hidden">
            <img
              src={panel_van}
              alt="Cargo Truck"
              className="w-full h-auto object-cover"
            />
            <Link to="/" className="block">
              <button className="bg-[#1E40AF] mb-4 mt-2 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition">
                Rent Now
              </button>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CommercialFleet;
